const EXPECTED_BACKEND_ERROR_PATTERNS = /Application name invalid|amazon\.(?:[\w-]+\.)?recar\.lt|HTTPSConnectionPool|Name or service not known|Socket closed|Max retries exceeded/i

export function isExpectedBackendError (error) {
	return EXPECTED_BACKEND_ERROR_PATTERNS.test(error?.message || error?.toString?.() || '')
}
